import { render, staticRenderFns } from "./RealEstateAddresses.vue?vue&type=template&id=1230db96&scoped=true&"
import script from "./RealEstateAddresses.vue?vue&type=script&lang=js&"
export * from "./RealEstateAddresses.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateAddresses.vue?vue&type=style&index=0&id=1230db96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1230db96",
  null
  
)

export default component.exports